export default __webpack_public_path__ + "static/media/spark_46.a038cfa7.png";